import React from 'react';
import CustomModal from '../../../../../components/CustomModal';
import { ITipoCargaSPE } from '../types/types';
import Form from './Form';

interface Props {
  isView?: boolean;
  isEdit?: boolean;
  onClear: () => void;
  onConfirm: () => void;
  selectedRow?: ITipoCargaSPE;
}

const Create: React.FC<Props> = (props: Props) => {
  return (
    <CustomModal title={props.isEdit ? "Editar Tipo de Carga SPE" : "Cadastrar Tipo de Carga SPE"} onClose={props.onClear}>
      <Form
        isView={props.isView}
        selectedRow={props.selectedRow}
        onConfirm={props.onConfirm}
        isEdit={props.isEdit}
        onClose={props.onClear}
      />
    </CustomModal>
  );
};

export default Create;
